import { type Direction, isCardinal } from "../../../engine/direction";
import { directionDelta } from "../../../engine/direction";
import { Particle } from "../particle";
import {
	constant,
	deceleratingMotion,
	easeOut,
	colorConstant,
	lerp,
	randomBetween,
	linearMotion,
	type RGBColor,
} from "../interpolation";

export class BulletTrailParticle extends Particle {
	/** Emission interval for generators (ms between particles). */
	static readonly emitIntervalMs = 200;

	/** Spawn offset from entity center in cell units (shifts behind the bullet). */
	static spawnOffset(direction?: Direction): { x: number; y: number } {
		if (!direction) return { x: 0, y: 0 };
		const delta = directionDelta(direction);
		return { x: -delta.x * 0.3, y: -delta.y * 0.3 };
	}

	constructor(originX: number, originY: number, direction?: Direction, color: RGBColor = { r: 35, g: 35, b: 35 }) {
		// Particles drift backward (opposite to travel direction)
		const delta = direction ? directionDelta(direction) : { x: 0, y: 0 };
		const len = Math.hypot(delta.x, delta.y) || 1;
		const speed = 2.5;
		const vx = (-delta.x / len) * speed;
		const vy = (-delta.y / len) * speed;

		super(originX, originY, {
			ttl: randomBetween(420, 470),
			size: lerp(0.4, 0.25),
			opacity: easeOut(0.6, 0.4),
			color: colorConstant(color.r, color.g, color.b),
			rotation: constant(direction && isCardinal(direction) ? 0 : 45),
			position: linearMotion(vx, vy),
		});
	}
}
